import React, {Component} from 'react';
import {Route, Switch, withRouter} from 'react-router-dom';
import styled from 'styled-components';
import {withAlert} from 'react-alert';
import PropTypes from 'prop-types';
import Header from './Header';
import TopBar from './menu/topMenu/TopBar';
import HomePage from './home/HomePage';
import Administration from './administration/Administration';
import Hdi from './hdi/Hdi';
import {
    ADMINISTRATION_PATH,
    HDI_PATH,
    HOME_PATH,
} from '../routes/paths';
import NotFoundPage from './NotFoundPage';
import SideBar from './menu/sideMenu/SideBar';

const Main = styled.div`
    display: flex;
    height: 100%;
    overflow: auto;
`;

const ContentWrapper = styled.div`
    flex: 1;
    margin-top: 6px;
    padding: 0 20px 0 20px;
    transition: all 0.5s ease;
    overflow-y: auto;
    overflow-x: hidden;
`;

const AppWrapper = styled.div`
    height: ${({isHomePage = false}) => isHomePage ? '' : '100vh'};
    display: flex;
    flex-direction: column;
`;

class AppContent extends Component {
    componentDidMount() {
        this.props.alert.show();
    }

    render() {
        const {store, location: {pathname}} = this.props;
        return (
            <AppWrapper isHomePage={pathname === HOME_PATH}>
                <div>
                    <Header/>
                    <TopBar/>
                </div>
                <Main>
                    <SideBar store={store}/>
                    <ContentWrapper id="contentWrapper">
                        <Switch>
                            <Route exact path={HOME_PATH} component={HomePage}/>
                            <Route path={ADMINISTRATION_PATH} component={Administration}/>
                            <Route path={HDI_PATH} component={Hdi}/>
                            <Route component={NotFoundPage}/>
                        </Switch>
                    </ContentWrapper>
                </Main>
            </AppWrapper>
        );
    }
}

AppContent.propTypes = {
    store: PropTypes.any.isRequired,
    alert: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
};

export default withRouter(withAlert(AppContent));
